export type CardType = 'win' | 'warning' | 'quote' | 'note';

export interface GroupedCardsNode {
  type: 'grouped_cards';
  children: unknown[];
  data?: {
    hName: string;
    hProperties: {
      className: string[];
    };
  };
}

export interface CardNode {
  type: 'card';
  cardType: CardType;
  children: unknown[];
  data?: {
    hName: string;
    hProperties: {
      className: string[];
      'data-card-type': CardType;
    };
  };
}

export const CARD_EMOJI_MAP: Record<CardType, string[]> = {
  note: ['📝', '📌', '💡', 'ℹ️', '📋'],
  quote: ['💬', '💭', '🗨️'],
  warning: ['⚠️', '🚨', '⚡'],
  win: ['✅', '🎉', '🏆', '💯'],
};

export const CARD_LABEL_MAP: Record<CardType, string[]> = {
  note: ['note', 'info', 'reminder'],
  quote: ['quote', 'said'],
  warning: ['warning', 'alert', 'caution'],
  win: ['win', 'success', 'achievement'],
};

export function detectCardType(text: string): CardType | null {
  const trimmed = text.trim();

  for (const [type, emojis] of Object.entries(CARD_EMOJI_MAP)) {
    if (emojis.some((emoji) => trimmed.startsWith(emoji))) {
      return type as CardType;
    }
  }

  const lowerText = trimmed.toLowerCase();
  for (const [type, labels] of Object.entries(CARD_LABEL_MAP)) {
    if (
      labels.some((label) => {
        const pattern = new RegExp(`^[^a-z]*${label}\\s*:`, 'iu');
        return pattern.test(lowerText);
      })
    ) {
      return type as CardType;
    }
  }

  return null;
}
